import {Filter} from 'odata-query';
import {ITag} from './DraggableTag';
import {FieldCategoryType} from './FieldView';

export type FieldType =
  | 'Text'
  | 'Keyword'
  | 'Number'
  | 'Float'
  | 'DateTime'
  | 'Date'
  | 'Time'
  | 'TextMultivalue'
  | 'Tag'
  | 'ExtractedText'
  | 'Export'
  | 'STR'
  | 'Long';

export interface IFieldModal {
  fieldId: number;
  fieldName?: string;
  fieldLabel: string;
  fieldTypeId?: number;
  fieldESType?: string;
  fieldUIType?: FieldType;
  fieldCategoryLabel?: string;
  fieldCategory: FieldCategoryType;
  userId?: number;
  isTag?: boolean;
  tagValues: ITag[];
  createdOn?: string;
  updatedOn?: string;
  fieldDateFormat?: string;
  canCustomize?: boolean;
  isMultiValueField?: boolean;
  isRelationShipField?: boolean;
  createdBy?: string;
  updatedBy?: string;
  hasTransferList?: boolean;
  isDocCustom?: boolean;
  isRelationalEditable?: boolean;
  isSortable?: boolean;
}

export const FieldCategoryMappingObj: Record<
  FieldCategoryType | 'NONE',
  string
> = {
  STANDARD_METADATA: 'Standard Metadata',
  CUSTOM_METADATA: 'Custom Metadata',
  TAG_FIELD: 'Tag',
  EXPORT: 'Export',
  STR: 'STR',
  NONE: 'NONE',
};

export type FieldUIType = 1 | 2 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13;

export const FieldUITypeMappingObj: Record<FieldUIType, FieldType> = {
  1: 'Keyword',
  2: 'DateTime',
  4: 'Text',
  5: 'Number',
  6: 'TextMultivalue',
  7: 'Tag',
  8: 'ExtractedText',
  9: 'Time',
  10: 'Date',
  11: 'Float',
  12: 'Long',
  13: 'STR',
};

export const FieldUITypeMappingByValue: Record<
  string,
  FieldUIType | FieldUIType[]
> = {
  Text: [1, 4],
  Keyword: 1,
  DateTime: 2,
  Number: 5,
  'Text Multivalue': 6,
  Tag: 7,
  'Extracted Text': 8,
  Time: 9,
  Date: 10,
  Float: 11,
  Long: 12,
  STR: 13,
};

export const FieldCategoryMappingByValue: Record<
  FieldCategoryType,
  Filter<FieldUIType>
> = {
  TAG_FIELD: {fieldTypeId: {eq: FieldUITypeMappingByValue['Tag']}},
  STANDARD_METADATA: {
    or: [
      {and: [{isSearchable: {eq: true}}, {isSystemField: {eq: true}}]},
      {
        and: [
          {isCustom: {eq: false}},
          {
            or: [
              {isStandard: {eq: true}},
              {isStandard: {eq: null}},
              {fieldTypeId: {eq: FieldUITypeMappingByValue['Keyword']}},
            ],
          },
        ],
      },
    ],
  },
  CUSTOM_METADATA: [
    {
      or: [
        {
          and: [
            {isSystemField: {ne: true}},
            {isCustom: {ne: false}},
            {fieldTypeId: {ne: FieldUITypeMappingByValue['Tag']}},
            {fieldTypeId: {ne: FieldUITypeMappingByValue['Export']}},
            {fieldTypeId: {ne: FieldUITypeMappingByValue['STR']}},
          ],
        },
        {
          and: [
            {isSystemField: {ne: true}},
            {isCustom: {eq: false}},
            {isStandard: {eq: false}},
            {fieldTypeId: {ne: FieldUITypeMappingByValue['Tag']}},
            {fieldTypeId: {ne: FieldUITypeMappingByValue['STR']}},
          ],
        },
      ],
    },
  ],
  EXPORT: {fieldTypeId: {eq: FieldUITypeMappingByValue['Export']}},
  STR: {fieldTypeId: {eq: FieldUITypeMappingByValue['STR']}},
};
